// extracted by mini-css-extract-plugin
export default {"cls1":"DoubleDigitCountBubble-cls1__wp","cls2":"DoubleDigitCountBubble-cls2_eU4 DoubleDigitCountBubble-cls1__wp"};